import './header';
import './footer';
import './newsletter';

new Vue({
  delimiters: ['[[', ']]'], // change because vue and django using the same args 
  el: '#footer',
  methods: {
    // cartPreview() {
    //   function updateCartPreview(items) {
    //     let cartPreview = document.querySelector('.cart-preview');
    //     if (cartPreview) {
    //       let itensCartPreview = document.querySelector('.items_cart_preview');
    //       itensCartPreview.innerHTML = '';

    //       items.forEach((item) => {
    //         let brandHtml = item.brand ? `<p class="cart-item-content-brand">${item.brand}</p>` : '';
    //         let formattedPrice = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(item.unit_price);
    //         let variations = item.variation_value ? `<p class="cart-item-content-size">Tamanho: <b>${item.variation_value}</b></p>` : '';

    //         let itemHTML = `
    //         <li class="cart-item">
    //           <figure>
    //             <img src="${item.image_medium}" alt="${item.name}">
    //           </figure>
    //           <div class="cart-item-content">
    //             ${brandHtml}
    //             <h4 class="cart-item-content-name">${item.name}</h4>
    //             <p class="cart-item-content-price">${formattedPrice}</p>
    //             <p class="cart-item-content-qtd">Quantidade: <b>${item.quantity}</b></p>
    //             ${variations}
    //           </div>
    //         </li>
    //         `;

    //         const liElement = document.querySelector(`li[itemSku="${item.sku}"]`);

    //         if (liElement) {
    //           liElement.classList.add('already-bought');
    //         }

    //         itensCartPreview.innerHTML += itemHTML;
    //       });

    //       localStorage.setItem('cartItems', JSON.stringify(items));

    //       // Adiciona o event listener para os botões de deletar
    //       document.querySelectorAll('.delete-item-button').forEach(button => {
    //         button.addEventListener('click', function () {
    //           let itemId = this.getAttribute('data-original-id');
    //           deleteCartItem(itemId);
    //         });
    //       });
    //     }
    //   }

    //   $.ajax({
    //     type: 'GET',
    //     url: '/api/front/cart/items/?version=2',
    //     headers: { 'Content-Type': 'application/json' },
    //     dataType: 'json'
    //   }).done(function (data) {
    //     if (data && data.cart_data && data.cart_data.items) {
    //       updateCartPreview(data.cart_data.items);
    //       let getActualQtd  = 0;
    //       for (var i = 0; i <= data.cart_data.items.length - 1; i++) {
    //         getActualQtd = Number(getActualQtd) + Number(data.cart_data.items[i].quantity);
    //       }
    //       const qtdHeader = document.querySelectorAll('.quant_itens_carrinho');
    //       if (qtdHeader) {
    //         qtdHeader.forEach((item) => {
    //           item.innerHTML = getActualQtd;
    //         });
    //       }
    //       const cartTotalValue = document.querySelector('.total_value_cart_preview');
    //       if (cartTotalValue) {
    //         cartTotalValue.innerHTML = data.cart_data.total;
    //       }
    //     }
    //   });

    //   $(document).on("ajaxComplete", function (event, xhr, settings) {
    //     if (settings.url.includes('/api/front/cart/items/') && settings.type === 'POST') {
    //       let valid_status = [200, 201];
    //       if (valid_status.includes(xhr.status)) {
    //         const responseJson = xhr.responseJSON.cart_data.items;
    //         let getActualQtd  = 0;
    //         for (var i = 0; i <= responseJson.length - 1; i++) {
    //           getActualQtd = Number(getActualQtd) + Number(responseJson[i].quantity);
    //         }
    //         const qtdHeader = document.querySelectorAll('.quant_itens_carrinho');
    //         if (qtdHeader) {
    //           qtdHeader.forEach((item) => {
    //             item.innerHTML = getActualQtd;
    //           });
    //         }
    //         const cartTotalValue = document.querySelector('.total_value_cart_preview');
    //         if (cartTotalValue) {
    //           cartTotalValue.innerHTML = xhr.responseJSON.cart_data.total;
    //         }
    //         updateCartPreview(responseJson);
    //       }
    //     }
    //   });
    // },
  },
  mounted() {
    // this.cartPreview();
  }
});

/* Header Padding fix */
var page404Element = document.querySelector('.page-404');

if (page404Element) {
  page404Element.style.paddingTop = '133px';
  page404Element.style.setProperty('padding-top', '133px', 'important');
}

document.addEventListener("DOMContentLoaded", function () {

  function loadSvg() {
    const svgs = document.querySelectorAll("[class^='no-svg-']");

    svgs.forEach(function (svg) {
      var oldClasses = svg.getAttribute("class");
      var newClasses = oldClasses.replace(/no-svg-/g, '');
      svg.setAttribute("class", newClasses);
    });
  }

  function onFirstScroll() {
    loadSvg();
    window.removeEventListener('scroll', onFirstScroll);
  }

  window.addEventListener('scroll', onFirstScroll, { passive: true });

  const containerShoppub = document.querySelector('#dynamic-page-extra .main-content .container-shoppub');
  if(containerShoppub) {
    const aboutStore = document.querySelector('#dynamic-page-extra #pagina-personalizada');
    if (aboutStore) {
      containerShoppub.classList.add('page-front');

      if($('.carrousel-photos')) {
        $('.carrousel-photos').slick({
          adaptiveHeight: true,
          arrows: true,
          initialSlide: 1,
          swipeToSlide: true, 
          touchThreshold: 100,
          dots: false,
          infinite: true,
          mobileFirst: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          speed: 100,
        });
      }
    }
  }

  (function ($) {
    $.fn.visible = function (partial) {

      var $t = $(this),
        $w = $(window),
        viewTop = $w.scrollTop(),
        viewBottom = viewTop + $w.height(),
        _top = $t.offset().top,
        _bottom = _top + $t.height(),
        compareTop = partial === true ? _bottom : _top,
        compareBottom = partial === true ? _top : _bottom;

      return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
    };

  })(jQuery);

  function loadWidgets(event) {
    $(".product-item:not(.widget-loaded)").each(function (i, el) {
        var $el = $(el); // Mantendo jQuery para verificar visibilidade
        if ($el.visible(true)) {
            $el.addClass("widget-loaded");
            $el.children().trigger("mouseenter");

            setTimeout(() => {
                const domEl = el; // Converter para elemento DOM nativo
                const appendBtn = domEl.querySelector('#append-btn');
                const btnBuy = domEl.querySelector('.action-control');

                if (appendBtn && btnBuy) {
                  appendBtn.appendChild(btnBuy);
                }
            }, 1000);
        }
    });
  }

  $(window).scroll(loadWidgets);
  setTimeout(loadWidgets, 0);

  const overlay = document.querySelector('.header__product-item--options-overlay');
  const options = document.querySelector('.header__product-item--options');
  
  // Função para adicionar os eventos de clique aos botões de compra
  function addBuyButtonEvent() {
    const allProducts = document.querySelectorAll('.product-item');
  
    allProducts.forEach(element => {
      const button = element.querySelector('.buybox');
      const optionsElement = element.querySelector('.product-item__options');
      
      if (button && optionsElement) {
        button.addEventListener('click', () => {
          options.innerHTML = ''; // Limpa opções anteriores
          options.append(optionsElement.cloneNode(true)); // Clonando o optionsElement para evitar conflito
          overlay.classList.add('active');
          options.classList.add('active');
          b2bItens(); // Chama a função para configurar eventos nas opções
        });
      }
    });
  }
  
  // Usando delegação de eventos no contêiner pai dos produtos
  document.body.addEventListener('click', (event) => {
    const button = event.target.closest('.buybox');
  
    if (button) {
      const element = button.closest('.product-item');
      const optionsElement = element.querySelector('.product-item__options');
  
      if (optionsElement) {
        options.innerHTML = ''; // Limpa opções anteriores
        options.append(optionsElement.cloneNode(true)); // Clonando o optionsElement
        overlay.classList.add('active');
        options.classList.add('active');
        b2bItens(); // Chama a função para configurar eventos nas opções
      }
    }
  });
  
  // Lógica para fechar o overlay ao clicar no overlay
  if (overlay) {
    overlay.addEventListener('click', () => {
      overlay.classList.remove('active');
      options.classList.remove('active');
      options.innerHTML = ''; // Limpa opções ao fechar
    });
  }
  
  // Chame a função uma vez para os produtos já existentes
  addBuyButtonEvent();
  
  
  /* If Black Friday Template enabled */
  var elements = document.querySelectorAll('.product-campaigns-tags__campaign');

  Array.from(elements).forEach(function (tag) {
    if (tag.textContent.includes("Black") || tag.textContent.includes("BLACK") || tag.textContent.includes("black")) {
      tag.classList.add("black");
    }
  });

  /* duvidas-frequentes tab_accordion */
  var tabAccordions = document.querySelectorAll('.tab_accordion');
  var contentAccordions = document.querySelectorAll('.content_accordion');

  tabAccordions.forEach(function (tabAccordion, index) {
    tabAccordion.addEventListener('click', function () {
      tabAccordions.forEach(function (tab) {
        tab.classList.remove('active');
      });

      contentAccordions.forEach(function (content) {
        content.classList.remove('active');
      });

      tabAccordion.classList.add('active');
      contentAccordions[index].classList.add('active');
    });
  });

  waitForElementToExist('#carrousel-comunicado').then(element => {
    const comunicado = document.querySelector('.comunicado');
    if (comunicado) {
      $('#carrousel-comunicado').slick({
        arrows: false,
        dots: false,
        infinite: true,
        autoplay: true,
        mobileFirst: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplaySpeed: 3000,
        speed: 2000,
        responsive: [
          {
            breakpoint: 991,
            settings: "unslick"
          },
        ]
      });
    }
  });


  const aboutThemes = document.querySelector('.about-themes');
  if (aboutThemes) {
    $('#carrousel-second-section').slick({
      arrows: false,
      dots: false,
      infinite: false,
      autoplay: true,
      mobileFirst: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 2000,
      responsive: [
        {
          breakpoint: 991,
          settings: "unslick"
        },
      ]
    });
  }

  waitForElementToExist('.rotation-banners').then(element => {
    let rotationVitrine = document.querySelector('.rotation-banners');
    if (rotationVitrine) {
      let rotationNames = rotationVitrine.querySelectorAll('.rotation-banners__title a');
      let initVitrine = rotationVitrine.querySelectorAll('.rotation-banners__list .item');
      initVitrine = Array.from(initVitrine);
  
      if (rotationVitrine && rotationNames.length && initVitrine.length) {
        initVitrine[0].classList.add('active');
        rotationNames[0].classList.add('active');
  
        function activeTab(index) {
          initVitrine.forEach((content) => {
            content.classList.remove('active');
          });
          rotationNames.forEach((content) => {
            content.classList.remove('active');
          });
          initVitrine[index].classList.add('active');
          rotationNames[index].classList.add('active');
  
          $('.banner-masculino__list').slick('refresh');
          $('.banner-feminino__list').slick('refresh');
        }
  
        rotationNames.forEach((itemMenu, index) => {
          itemMenu.addEventListener('click', (e) => {
            e.preventDefault();
            activeTab(index);
          });
        })
      }
    }  

    $('.banner-masculino__list').slick({
      arrows: true,
      dots: false,
      autoplay: true,
      autoplaySpeed: 5000,
      infinite: true,
      mobileFirst: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 1000,
      responsive: [
        {
          breakpoint: 567,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 7,
            slidesToScroll: 1,
          }
        }
      ]
    })

    $('.banner-feminino__list').slick({
      arrows: true,
      dots: false,
      autoplay: true,
      autoplaySpeed: 5000,
      infinite: true,
      mobileFirst: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 1000,
      responsive: [
        {
          breakpoint: 567,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 7,
            slidesToScroll: 1,
          }
        }
      ]
    })
  });


  $("body").on("click", '.product-item__qtd__minus', function (event) {
    event.preventDefault();
    var $input = $(this).closest('.product-item__qtd').find('.product-item__qtd__text');
    var qtd = parseInt($input.val(), 10);

    if (qtd > 1) {
      qtd--;
      $input.val(qtd).attr('value', qtd);
    }
  });

  $("body").on("click", '.product-item__qtd__plus', function (event) {
    event.preventDefault();
    var $input = $(this).closest('.product-item__qtd').find('.product-item__qtd__text');
    var qtd = parseInt($input.val(), 10);

    qtd++;
    $input.val(qtd).attr('value', qtd);
  });

  $("body").on("click", '.not-available-grid', function (event) {
    event.preventDefault();
    var $input = $(this);
    let payload = [];
    payload.push({
      product: $input.attr('data-id'),
      quantity: 1,
      replace_quantity: true,
      is_buying_by_measure: false
    });

    if (payload.length > 0) {
      $.ajax({
        type: 'POST',
        url: '/api/front/cart/items/?version=2',
        data: JSON.stringify(payload),
        headers: { 'Content-Type': 'application/json' },
        dataType: 'json'
      }).fail(function (jqXHR, textStatus, errorThrown) {
        var data = jqXHR.responseJSON;
        for (var i in data) {
          if ('unavailable' in data[i]) {
            var d = data[i].unavailable;
            Swal.fire({
                imageUrl: d.product.image,
                html: '<strong>' + d.product.name + '</strong>' +
                    '<p>' + d.message + '</p>',
                input: 'text',
                inputPlaceholder: 'Informe seu e-mail:',
                showCancelButton: true,
                confirmButtonText: 'Cadastrar aviso',
                cancelButtonText: 'Cancelar',
                showLoaderOnConfirm: true,
                preConfirm: function (email) {
                    return new Promise(function (resolve, reject) {
                        product_detail_service.notify('', email, {}, d.product.id);
                        resolve();
                    });
                }
            });
          }
        };
      });
    }
  });

  function b2bItens() {
    // Função para converter uma string de moeda brasileira para número
    function parseBrazilianCurrency(value) {
      // Remove os pontos de milhar e substitui a vírgula decimal por um ponto
      value = value.replace(/\./g, '').replace(',', '.');
      // Converte para número float
      return parseFloat(value);
    }

    // Armazena o valor anterior dos inputs para calcular a diferença
    let previousValues = {};

    // Função genérica para aplicar a lógica em um contêiner específico
    function applyLogicToContainer(containerSelector) {
      // Aplica a lógica aos elementos dentro do contêiner
      const $container = $(containerSelector);

      if (!$container.find('.product-radio-variation.b2b').length) {
        addToCart($container);
        return;
      }

      $container.find('input[id^="product_item_variation__product_detail_"]').each(function () {
        // Inicializa o valor anterior no carregamento da página
        previousValues[$(this).attr('id')] = parseBrazilianCurrency($(this).attr('data-price')) * Number($(this).val());
      });

      $container.find('input[id^="product_item_variation__product_detail_"]').on('change', function () {
        var $el = $(this);

        // Obtém o ID do input
        const inputId = $el.attr('id');

        // Obtém o preço da variação do atributo data-price
        const variationPrice = parseBrazilianCurrency($el.attr('data-price'));

        // Obtém a quantidade da variação
        const variationQtd = Number($el.val());

        // Calcula o valor atual baseado no preço e na quantidade
        const currentValue = variationPrice * variationQtd;

        // Obtém o preço total atual e o converte para número
        const totalValue = parseBrazilianCurrency($container.find('.price-table').attr('data-price'));

        // Calcula a diferença entre o valor atual e o valor anterior
        const previousValue = previousValues[inputId] || 0;
        const difference = currentValue - previousValue;

        // Atualiza o valor total
        const newValue = totalValue + difference;

        // Atualiza o atributo data-price com o novo valor total
        $container.find('.price-table').attr('data-price', newValue.toFixed(2).replace('.', ','));

        // Atualiza o valor anterior para o próximo cálculo
        previousValues[inputId] = currentValue;
      });

      // Lógica para adicionar ao carrinho
      addToCart($container);

    }

    function addToCart(containerSelector) {
      const $container = $(containerSelector);
      $container.find('.b2b-button').click(function () {
        let payload = [];
        let isB2b = false;
        if ($container.find('.product-radio-variation').hasClass('b2b')) {
          isB2b = true;
          $container.find('input[id^="product_item_variation__product_detail_"]').each(function () {
            let $el = $(this);
            let value = Number($el.val());
            if (value > 0) {
              payload.push({
                as_free: false,
                product: Number($el.attr('data-id')),
                quantity: value,
                replace_quantity: true,
              });
            }
          });
        }else {
          let $el = $($container).find('input[id^="product_item_variation__product_detail_"]:checked');
          let value = Number($($container).find('.product-item__qtd input').val());
          if (value > 0) {
            payload.push({
              product: Number($el.attr('data-id')),
              quantity: value,
              replace_quantity: true,
              is_buying_by_measure: false
            });
          }
        }

        if (payload.length > 0) {
          let url;
          if(isB2b) {
            url = '/api/front/cart/items/?version=2';
          }else {
            url = '/api/front/cart/items/?version=2';
          }
          $.ajax({
            type: 'POST',
            url: url,
            data: JSON.stringify(payload),
            headers: { 'Content-Type': 'application/json' },
            dataType: 'json'
          }).done(function (data, textStatus, jqXHR) {
            if ($container.hasClass('product-detail__header--infoArea')) {
              if (conf_detalhe_produto_exibir_modal_continuar_comprando) {
                cart_preview.renderCartPreview();
                $("a.js-keeping-buying").fancybox().trigger('click');
              } else {
                location = url_carrinho;
              }
            } else {
              const overlay = document.querySelector('.header__product-item--options-overlay');
              const options = document.querySelector('.header__product-item--options');

              if (overlay && options) {
                overlay.classList.remove('active');
                options.classList.remove('active');
                options.innerHTML = '';
              }
            }
          }).fail(function (jqXHR, textStatus, errorThrown) {
            handleAjaxFail(jqXHR.responseJSON);
          });
        } else {
          alert('Por favor, selecione a quantidade.');
        }
      });
    }

    // Função para tratar falhas no AJAX
    function handleAjaxFail(data) {
      data.forEach(function (item) {
        if (item.stock) {
          alert(`O produto <strong>"${item.stock.product.name}"</strong> possui <strong>${item.stock.quantity}</strong> unidade(s) em estoque.`);
          return false;
        }

        if (item.limit_itens) {
          alert(item.limit_itens.message);
          return false;
        }

        if (item.buy_rules) {
          showBuyRulesWarning(item.buy_rules);
          return false;
        }
      });
    }

    // Função para exibir regras de compra
    function showBuyRulesWarning(buyRules) {
      let warning = `
      Quantidade solicitada para esta grade: <strong>${buyRules.quantity_total_grid_on_cart}</strong><br><br>
      Para o produto <strong>${buyRules.products[0].product_parent_or_self.name}</strong> é necessário comprar a grade conforme as regras abaixo:<br><br>
      <table class="behaviour-grid__table">
          <thead>
              <tr>
                  <th><strong>Total por grade</strong></th>
                  <th><strong>Total mínimo</strong></th>
                  <th><strong>Mínimo por variação</strong></th>
              </tr>
          </thead>
          <tbody>
  `;

      buyRules.grade_rules.forEach(function (rule) {
        let isCurrentRule = parseInt(buyRules.quantity_total_grid_on_cart) === parseInt(rule.total_quantity_that_must_be_purchased_in_the_grid);
        warning += `
          <tr${isCurrentRule ? ' style="color:red; text-decoration: underline;"' : ''}>
              <td>${formatRuleQuantity(rule.total_quantity_that_must_be_purchased_in_the_grid, rule.total_quantity_must_be_multiple_of_itself)}</td>
              <td>${formatRuleQuantity(rule.minimum_amount_that_must_be_purchased_in_the_grid)}</td>
              <td>${formatRuleQuantity(rule.minimum_amount_that_must_be_purchased_by_product, rule.minimum_amount_must_be_multiple_of_itself, rule)}</td>
          </tr>
      `;
      });

      warning += '</tbody></table>';
      alert(warning);
    }

    // Formatação das quantidades de regras
    function formatRuleQuantity(quantity, isMultiple = false, rule = null) {
      if (!quantity) return 'sem limite';
      let formatted = isMultiple ? `múltiplo de ${quantity}` : `${quantity}`;
      if (rule) {
        if (!rule.close_grid) formatted += ' (grade aberta)';
        else formatted += ` (grade fechada${rule.variations_not_required ? ` (não obrigatório: ${rule.variations_not_required.split(",").join(", ")})` : ''})`;
      }
      return formatted;
    }

    // Executa a função para os dois contextos diferentes
    applyLogicToContainer('.product-detail__header--infoArea');
    applyLogicToContainer('.header__product-item--options');

  }

  b2bItens();

});

const pageExtraCarrosel = document.querySelector('#dynamic-page-extra .image-list');
if (pageExtraCarrosel) {
  $('#dynamic-page-extra .image-list').slick({
    arrows: false,
    dots: false,
    infinite: false,
    autoplay: true,
    mobileFirst: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 2000,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        }
      },
    ]
  });
}

